//@flow

import React from 'react'
import { useAction, useAtom } from '@reatom/react'
import { useTranslation } from 'react-i18next'

import { usePrimaryPayment } from '@bfg/effects/primaryPayment'
import { PaymentAtom } from '@bfg/atoms/Payment'
import { WebViewDetectorAtom } from '@bfg/atoms/WebViewDetector'
import { domain } from '@bfg/common'
import { WalletType } from '@bfg/enums/WalletTypesEnum'
import { useCardPay } from '@bfg/effects/cardPay'
import { useSkipStepExperiment } from '@bfg/contexts/ExperimentsContext'
import { usePaymentType } from '@bfg/contexts/PaymentTypeContext'
import { PaymentType } from '@bfg/enums/PaymentTypesEnum'
import { useWalletType } from '@bfg/contexts/WalletTypeContext'
import { usePaymentPayed, usePaymentTrialState } from '@bfg/contexts/PaymentStateContext'
import {
  useFinalStep,
  useClickBackHandle,
  usePrevStep,
  useCurrentStep,
  useNextStep,
  useClickNextHandle, useStepsLength
} from '@bfg/contexts/StepsContext'
import { gtagEventNew } from '@bfg/utils/gtag'
import { IncrementPaymentClickCount } from '@bfg/atoms/AppConfig'
import { resolvePaymentTypeObject } from '@bfg/effects/paymentType'

export const MobileStepsToolbarUnified = (props) => {
  return (
    <MobileStepsToolbar/>
  )
}

export const MobileStepsToolbar = () => {
  const lastStep = useFinalStep()
  const paymentPayed = usePaymentPayed()
  const paymentTrialState = usePaymentTrialState()

  const payed = paymentPayed || paymentTrialState

  const showTrialButton = lastStep && !payed && paymentPayed !== null

  return (
    <nav className="mobile-timeline">
      <ul>
        <BackButton/>
        {!lastStep && (
          <NextButton/>
        )}
        {showTrialButton && (
          <TrialButton/>
        )}

      </ul>
    </nav>
  )
}
export const MobileStepsToolbarExperiment = () => {
  const lastStep = useFinalStep()
  const paymentPayed = usePaymentPayed()
  const paymentTrialState = usePaymentTrialState()

  const payed = paymentPayed || paymentTrialState

  const showTrialButton = lastStep && !payed && paymentPayed !== null

  return (
    <nav className="mobile-timeline mobile-timeline-expirement">
      <ul>
        <BackButton/>
        {!lastStep && (
          <NextButton/>
        )}
        {showTrialButton && (
          <TrialButton/>
        )}

      </ul>
    </nav>
  )
}

const BackButton = () => {
  const { t } = useTranslation()
  const handleClickBack = useClickBackHandle()
  const isPrevStepAvailable = usePrevStep()
  const prevClass = isPrevStepAvailable ? '' : 'disable'

  return (
    <li>
      <a
        className={`prev-step ${prevClass}`}
        title={t('stepsToolbar.Previous')}
        onClick={handleClickBack}>
        <span className="bm_icon_arrow"/>
      </a>
    </li>
  )
}

const NextButton = () => {
  const webviewAtom = useAtom(WebViewDetectorAtom)
  const { t } = useTranslation()
  // const stepsHandler = useSteps();

  const currentStep = useCurrentStep()
  const isNextStepAvailable = useNextStep()
  const handleClickNext = useClickNextHandle()
  const stepsLength = useStepsLength()

  const stepId = currentStep.id
  const nextClass = isNextStepAvailable || stepId === 3 ? 'enabled-green' : 'disable'

  let handleNext
  if (webviewAtom.isWebView && webviewAtom.isAndroid) {
    handleNext = () => {
      window.location = `intent:${domain}${window.location.search}#Intent;end`
    }
  } else {
    handleNext = handleClickNext
  }

  const stepName = t(`steps.mobile.${currentStep.mobileName}`)
  return (
    <li>
      <a onClick={handleNext}
         className={`next-step ${nextClass}`}
         title={stepName}>
          <span className="next-step-text-box">
          {stepName}<span>{t('stepsToolbar.Step')} {stepId} / {stepsLength}</span>
          </span>
        <span className="bm_icon_arrows"/>
      </a>
    </li>
  )
}

const TrialButton = () => {

  const paymentState = useAtom(PaymentAtom)
  const paymentType = usePaymentType()
  const isSubscription = paymentType !== PaymentType.OneTimePayment

  const walletType = useWalletType()

  const { t } = useTranslation()

  const paymentHandler = usePrimaryPayment()

  const paymentTypeObject = resolvePaymentTypeObject(paymentState.aPay)

  const trialStepName = paymentTypeObject?.couponId === null
    ? t('stepsToolbar.Try For Free')
    : t('stepsToolbar.See Your Baby')

  return (
    <>
      {walletType === WalletType.Wallet && (
        <WalletTrial
          paymentHandler={paymentHandler.handlePayment}
          trialStepName={trialStepName}
        />
      )}
      {walletType === WalletType.Card && (
        <CardTrial
          paymentHandler={paymentHandler.handlePayment}
          trialStepName={trialStepName}
          isSubscription={isSubscription}
        />
      )}
    </>
  )
}

function WalletTrial (props) {

  const { t } = useTranslation()
  const currentStep = useCurrentStep()
  const stepsLength = useStepsLength()

  const stepId = currentStep.id
  return (
    <li className="trial-button">
      <a onClick={
        () => {
          gtagEventNew('payment_tapped_new')

          props.paymentHandler()

          gtagEventNew('payment_clicked_new')
        }
      }
         className="next-step"
         title={props.trialStepName}
      >
          <span className="next-step-text-box">
            {props.trialStepName}
            <span>{t('stepsToolbar.Step')} {stepId} / {stepsLength}</span>
          </span>
        <span className="bm_icon_arrows"/>
      </a>
    </li>
  )
}

/**
 * Кнопка оплаты картой в мобильном тулбаре.
 *
 * Раньше здесь же рендерился <Elements><CardPopup/></Elements>. Убрано:
 * CardPopup сейчас не используется, а провайдер Elements тянул
 * @stripe/react-stripe-js (44 КБ) в стартовый бандл — тулбар рендерится на
 * каждом экране, включая первый. Потребителей контекста Elements в проекте
 * нет вообще: ни useStripe, ни useElements, ни CardElement нигде не вызываются.
 *
 * Ленивые экраны оплаты (PayScreen, PayScreenCoupon) импортируют Elements
 * сами; там библиотека попадает в их собственные чанки и стартовый вес не
 * трогает.
 */
function CardTrial (props) {
  const { t } = useTranslation()
  const currentStep = useCurrentStep()
  const stepsLength = useStepsLength()
  const stepId = currentStep.id

  const cardPayHandler = useCardPay()

  return (
    <li className="trial-button">
      <a onClick={cardPayHandler.showPopup}
         className="next-step"
         title={props.trialStepName}>
          <span className="next-step-text-box">
            {props.trialStepName}<span>{t('stepsToolbar.Step')} {stepId} / {stepsLength}</span>
          </span>
        <span className="bm_icon_arrows"/>
      </a>
    </li>
  )
}